import React, { Component } from 'react';

class Terms extends Component {
  render () {
    return (
      <main className='main'>
        <div className='l-container'>
          <h1 className='u-text-center'>Terms & Conditions</h1>
          <div className='island' style={{'height': '800px'}}>
            <iframe
              title="terms"
              style={{'width': '800px', 'height': '750px'}}
              src='/terms.html'
              className='scribd_iframe_embed'
              width='100%'
              height='730'
              frameBorder='0'>
            </iframe>
          </div>
        </div>
      </main>
    );
  }
}

export default Terms;



// WEBPACK FOOTER //
// ./src/views/Main/Terms/index.js